const messages = {
  name: 'Backup / Restore',
  accessDenied: 'Only a SuperUser can access database backup and restore.',
  schedule: {
    title: 'Automatic backup',
    intro: 'Schedules automatic encrypted copies of the database. The server keeps them locally, optionally uploads them to Google Drive and deletes the oldest ones according to the retention. The encryption passphrase is configured on the server.',
    introDrive: 'Schedules automatic encrypted copies of the database. The server keeps them locally and uploads them to Google Drive, deleting the oldest ones according to the retention. The encryption passphrase is configured on the server.',
    enable: 'Enable automatic backup',
    intervalHours: 'Period (hours)',
    intervalHoursHint: 'How often a copy is made. 24 = daily.',
    dailyHourUtc: 'Hour of day (UTC)',
    dailyHourUtcHint: 'Hour (0-23) of the first copy of the day.',
    retention: 'Copies on the server',
    retentionHint: 'The oldest ones are deleted. 0 = keep all.',
    driveRetention: 'Copies on Drive',
    driveRetentionHint: 'The oldest ones are deleted. 0 = keep all.',
    driveDisabledHint: 'Drive is not configured on the server.',
    lastRun: 'Last copy',
    nextRun: 'Next copy',
    save: 'Save schedule',
    saving: 'Saving...',
    saved: 'Schedule saved',
    saveError: 'Failed to save the schedule',
    loadError: 'Could not load the schedule',
    noPassphrase: 'The server has no backup passphrase configured: even if you enable the schedule, no automatic backups will run.',
  },
  backup: {
    title: 'Manual backup',
    hint: 'Download an encrypted copy of the database now. You will need this same passphrase to restore it; without it the contents cannot be recovered.',
    passphrase: 'Passphrase',
    passphraseHint: 'Minimum %{min} characters.',
    passphraseConfirm: 'Repeat the passphrase',
    passphraseMismatch: 'Passphrases do not match.',
    download: 'Download backup',
    downloading: 'Downloading...',
    started: 'Backup download started',
    error: 'Could not generate the backup',
  },
  restore: {
    title: 'Restore',
    warning: 'WARNING: restoring completely OVERWRITES the current database with the file contents. Current data will be lost irreversibly.',
    file: 'Backup file (.rmtkbk)',
    passphrase: 'Backup passphrase',
    restore: 'Restore',
    restoring: 'Restoring...',
    ok: 'Database restored successfully',
    error: 'Could not restore the backup',
    confirmTitle: 'Restore database?',
    confirmBody: 'This action replaces the ENTIRE current database with the backup contents. The operation is destructive and irreversible. Are you sure you want to continue?',
  },
};

export default messages;
